import { connect } from 'react-redux';

import TagList from './tagList';

const mapStateToProps = state => ({
  breadcrumbLinks: state.app.pageData.breadcrumb
});

export default connect(mapStateToProps)(TagList);
